


































































































import { defineComponent, reactive, SetupContext, toRef, toRefs, onMounted } from "@vue/composition-api";
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { QuestionnaireGroup, Questionnaire, QuestionnaireOption } from "../../modules/teacher/LessonQuestionnaireEdit";

interface Data {
  lesson_class_id: string
  lesson_name: string
  lesson_class_no: string
  questionnaire_group: QuestionnaireGroup
  errors: string[];
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      lesson_class_id: null,
      lesson_name: "",
      lesson_class_no: "",
      questionnaire_group: new QuestionnaireGroup(),
      errors: [],
    });


    const addQuestionnaire = () => {
      const questionnaire = new Questionnaire();
      const option = new QuestionnaireOption();
      option.sort_no = 1;
      questionnaire.questionnaire_options.push(option);
      const sort_nos = state.questionnaire_group.questionnaires.map(x => x.sort_no);
      const sort_no = sort_nos.length > 0 ? Math.max(...sort_nos) + 1 : 1;
      questionnaire.sort_no = sort_no;
      state.questionnaire_group.questionnaires.push(questionnaire);
    }

    const addQuestionnairOption = (questionnaire: Questionnaire) => {
      const option = new QuestionnaireOption();
      const sort_nos = questionnaire.questionnaire_options.map(x => x.sort_no);
      const sort_no = sort_nos.length > 0 ? Math.max(...sort_nos) + 1 : 1;
      option.sort_no = sort_no;
      questionnaire.questionnaire_options.push(option);
    }

    const deleteQuestionnair = (q_idx: number) => {
      state.questionnaire_group.questionnaires.splice(q_idx, 1);
      state.questionnaire_group.questionnaires.forEach((x, i) => {
        x.sort_no = i + 1;
      });
    }

    const deleteQuestionnairOption = (q_idx: number, o_idx: number) => {
      state.questionnaire_group.questionnaires[q_idx].questionnaire_options.splice(o_idx, 1);
      state.questionnaire_group.questionnaires[q_idx].questionnaire_options.forEach((x, i) => {
        x.sort_no = i + 1;
      });
    }

    const swapQuestionnairs = (idx: number, isPlus: boolean) => {
      const questionnaires = swapArrayElements(state.questionnaire_group.questionnaires, idx, isPlus) as Questionnaire[];
      state.questionnaire_group.questionnaires = questionnaires;
      state.questionnaire_group.questionnaires.forEach((x, i) => {
        x.sort_no = i + 1;
      });
    }

    const swapQuestionnairOptions = (q_idx: number, o_idx: number, isPlus: boolean) => {
      const questionnaire_options = swapArrayElements(state.questionnaire_group.questionnaires[q_idx].questionnaire_options, o_idx, isPlus) as QuestionnaireOption[];
      state.questionnaire_group.questionnaires[q_idx].questionnaire_options = questionnaire_options;
      state.questionnaire_group.questionnaires[q_idx].questionnaire_options.forEach((x, i) => {
        x.sort_no = i + 1;
      });
    }

    const swapArrayElements = (arr: any, idx: number, isPlus: boolean) => {
      
      if ((idx == 0 && !isPlus) || (idx >= arr.length - 1 && isPlus)) {
        // 配列の範囲外の場合は何もしない
        return arr;
      }
      
      const temp = arr[idx];
      if (isPlus) {
        arr[idx] = arr[idx + 1];
        arr[idx + 1] = temp;
      } else {
        arr[idx] = arr[idx - 1];
        arr[idx - 1] = temp;
      }

      return arr
    }

    /******************************
     * 戻るボタン押下
     ******************************/

    const goBack = (): void => {
      context.root.$router.go(-1);
    };

    const saveClick = async () => {
      state.errors = [];
      state.questionnaire_group.questionnaires.forEach(questionnaire => {
        if(!questionnaire.question_text){
          state.errors.push(`質問${questionnaire.sort_no}の質問文が入力されていません。`);
        }
        questionnaire.questionnaire_options.forEach(questionnaire_option => {
          if(!questionnaire_option.option_text){
            state.errors.push(`質問${questionnaire.sort_no}・回答${questionnaire_option.sort_no}の回答文が入力されていません。`);
          }
        });
      });

      if(state.errors.length > 0){
        return;
      }

      if(!window.confirm("アンケートを保存します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      
      await http.post(`/api/teacher/lesson_questionnaire_edit/update/${state.lesson_class_id}`, {questionnaire_group: state.questionnaire_group}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(async error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
        window.scroll({top: 0, behavior: 'smooth'});
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      state.lesson_class_id = context.root.$route.params.lesson_class_id;
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/lesson_questionnaire_edit?lesson_class_id=${state.lesson_class_id}`).then(response => {
        state.lesson_name = response.data.lesson_data.name;
        state.lesson_class_no = response.data.lesson_class_no;
        if(response.data.questionnaire_group){
          state.questionnaire_group = new QuestionnaireGroup(response.data.questionnaire_group, response.data.questionnaires, response.data.questionnaire_options)
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      goBack,
      addQuestionnaire,
      addQuestionnairOption,
      deleteQuestionnair,
      deleteQuestionnairOption,
      swapQuestionnairs,
      swapQuestionnairOptions,
      saveClick,
    };
  },
})
